<!-- 更新日志管理页面 -->
<template>
  <div>
    <div class="search-row">
      <div class="search-item">
        <span class="mr5">发布版本</span>
        <el-select v-model="queryParams.version" size="mini" clearable :placeholder="`请选择`">
          <el-option v-for="item in iterationVersionList" :key="item.id" :label="item.name" :value="item.name"> </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="mr5">更新日志标题</span>
        <el-input class="input230" v-model="queryParams.title" size="mini" clearable />
      </div>
      <div>
        <el-button size="mini" type="primary" @click="search">查询</el-button>
        <el-button size="mini" type="primary" @click="openDialog(`新增更新日志`, 'new')">新增更新日志</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table class="mt10" ref="multipleTable" border :data="list" @sort-change="sortChange">
      <el-table-column type="index" label="#" width="55"></el-table-column>
      <el-table-column :sortable="!!item.sortKey ? 'custom' : false" :sort-by="item.sortKey" v-for="item in columns" :label="item.text" :key="item.column" :width="item.width">
        <template slot-scope="scope">
          <!-- 操作 -->
          <template v-if="item.column == 'handle'">
            <el-button type="text" @click="openDialog(`修改日志`, 'edit', scope.row)">编辑</el-button>
            <el-button type="text" @click="openDialog(`查看日志`, 'check', scope.row)">查看</el-button>
            <el-button type="text" @click="deleteData(scope.row)">删除</el-button>
          </template>
          <span v-else>{{ scope.row[item.column] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :queryParams="queryParams" :getList="getList" />

    <!-- 新增和修改的弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1200px" @close="onClose">
      <el-form ref="form" :disabled="disabled" :rules="rules" :model="form" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="`发布版本`" prop="version">
              <el-input maxlength="30" class="input-width" v-model="form.version"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="`发布时间`" prop="publish_time">
              <el-date-picker type="datetime" class="input-width" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.publish_time" :placeholder="`选择日期`"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="`更新日志标题`" prop="title">
              <el-input maxlength="30" class="input-width" v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="`更新日志内容`" prop="content">
          <el-input type="textarea" :rows="4" maxlength="500" class="textarea-width" v-model="form.content"></el-input>
        </el-form-item>
      </el-form>
      <div class="row-center">
        <el-button @click="closeFun">取消</el-button>
        <el-button class="ml20" type="primary" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import { iterationLogSave, iterationLogDelete, iterationLog, getIterationVersion } from '@/api.js';
import { pageSize } from '@/utils/Config';
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      disabled: false,
      iterationVersionList: [],
      isEdit: false,
      rules: {
        version: [{ required: true, message: `请输入`, trigger: 'blur' }],
        publish_time: [{ required: true, message: `请选择`, trigger: 'blur' }],
        title: [{ required: true, message: `请输入`, trigger: 'blur' }],
        content: [{ required: true, message: `请输入`, trigger: 'blur' }],
      },
      dialogVisible: false,
      dialogTitle: '',
      list: [],
      columns: [],
      queryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      form: {
        content: '',
        version: '',
        publish_time: '',
        title: '',
      },
    };
  },
  created() {
    this.getList();
    this.getIterationVersionFun();
  },
  methods: {
    // 获取版本号
    getIterationVersionFun() {
      this.$request('get', getIterationVersion).then((res) => {
        if (res) {
          this.iterationVersionList = res;
        }
      });
    },
    // 获取列表数据
    getList() {
      const { pageIndex, pageSize, title, version } = this.queryParams;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        title,
        version,
      };
      this.$request('get', iterationLog, query).then((res) => {
        if (res) {
          this.list = res.data;
          this.columns = res.columns;
          this.queryParams._total = res.total;
        }
      });
    },

    // 搜索
    search() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },

    // 关闭按钮：
    closeFun() {
      this.dialogVisible = false;
    },

    // 当弹框关闭时：
    onClose() {
      this.form = {
        content: '',
        version: '',
        publish_time: '',
        title: '',
      };
      this.$refs.form.resetFields();
    },

    // 弹框里的确认
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let { version, publish_time, title, content } = this.form;
          let query = {
            content,
            version,
            publish_time,
            title,
          };
          if (this.isEdit) {
            query.id = this.id;
          }
          this.$request('post', iterationLogSave, query).then((res) => {
            if (res) {
              this.dialogVisible = false;
              this.search();
              this.getIterationVersionFun();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 新增
    openDialog(title, isEdit, data) {
      if (isEdit == 'edit' || isEdit == 'check') {
        // 是编辑时：
        this.id = data.id;
        this.form = {
          version: data.version,
          publish_time: data.publish_time,
          title: data.title,
          content: data.content,
        };
        if (isEdit == 'check') {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      } else {
        this.disabled = false;
      }
      this.dialogVisible = true;
      this.dialogTitle = title;
      this.isEdit = isEdit;
    },

    // 删除：
    deleteData(data) {
      var publish_time = new Date(data.publish_time);
      var currentDate = new Date();
      if (publish_time < currentDate) {
        this.$message.warning(`已经发布过的数据不能被删除`);
        return;
      }
      this.$confirm(`是否确认删除`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.$request('post', iterationLogDelete, {
          id: data.id,
        }).then((res) => {
          if (res) {
            this.getList();
            this.getIterationVersionFun();
            this.$message({
              type: 'success',
              message: `删除成功`,
            });
          }
        });
      });
    },

    // 排序方法
    sortChange(item) {
      const { column, order } = item;
      const orderString = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined;
      const orderBy = order ? column.sortBy : undefined;

      this.queryParams.order = orderString;
      this.queryParams.orderBy = orderBy;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.search-row {
  display: flex;
}
.search-item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 20px;
  span {
    display: inline;
  }
}
.inputClass {
  white-space: nowrap; /* 强制单行显示 */
  text-overflow: ellipsis; /* 超出部分省略号表示 */
  overflow: hidden; /* 超出部分隐藏 */
  width: 154px; /* 设置显示的最大宽度 */
  display: inline-block; /* 转变为行内块体元素，以便设置宽度和高度 */
}
.row-center {
  text-align: center;
}
.input-width {
  width: 250px;
}
.textarea-width {
  width: 1027px;
}
</style>
